import { SET_WATCHES, SET_WATCH_DRAWER_OPEN } from '../../actionTypes/watch'

const initialState = {
	watches: [],
	drawerOpen: false,
}

export function watchReducer (state = initialState, action) {
	switch (action.type) {
		case SET_WATCHES:
			return {
				...state,
				watches: action.value,
			}
		case SET_WATCH_DRAWER_OPEN:
			return {
				...state,
				drawerOpen: action.value,
			}
		default:
			return state
	}
}
